import { AsanAction, AsanRequest } from './types';

const AUTH_FORM_ID = 'authorization_b2b';
const AUTH_URL = `/api-web/v1/main/${AUTH_FORM_ID}`;

interface Params {
  action: AsanAction;
  /** Signing endpoint. `undefined` → authorization (login) flow. */
  pathUrl?: string;
  businessKey?: string;
  /** business_key from router location.state (authorization flow) */
  stateBusinessKey?: string;
  repeatAction?: string;
  taskReference?: string;
}

/**
 * Builds the ASAN polling / cancel / repeat request.
 * Mirrors the legacy useConfirmAsanImza branches 1:1, including the quirk that in the
 * authorization flow only `check` falls back from businessKey to location.state.
 */
export const resolveAsanRequest = ({
  action,
  pathUrl,
  businessKey,
  stateBusinessKey,
  repeatAction,
  taskReference,
}: Params): AsanRequest => {
  // Legacy check is `pathUrl !== undefined` (null still counts as a signing endpoint).
  if (pathUrl !== undefined) {
    const url = `${pathUrl}?business_key=${businessKey}`;

    if (action === 'check') {
      return {
        data: { action: 'check', ...(taskReference ? { task_reference: taskReference } : {}) },
        url,
      };
    }
    if (action === 'cancel') return { data: { action: 'cancel' }, url };

    return { data: { action: repeatAction ?? 'repeat_code' }, url };
  }

  if (action === 'check') {
    return {
      data: { action: 'check', form_id: AUTH_FORM_ID },
      url: `${AUTH_URL}?business_key=${businessKey ?? stateBusinessKey}`,
    };
  }

  return {
    data: { action: action === 'cancel' ? 'cancel' : 'repeat_code', form_id: AUTH_FORM_ID },
    url: `${AUTH_URL}?business_key=${stateBusinessKey}`,
  };
};
